import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { tournamentService } from '@/services/tournament';

export function useTournamentLeaderboardList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: tournamentService.leaderboard.list,
        paramsBuilder: () => query,
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: tournamentService.leaderboard.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
